import {Card, Spin, Typography} from "antd";
import {useEffect} from "react";
import Plural from "./Plural";

export default function InternalSummaryPanel({summary, report}) {
    const fontFamily = window.location.pathname.includes('/app/report') ? 'Calibri' : 'Segoe UI'
    const fontSize = window.location.pathname.includes('/app/report') ? '11pt' : '9pt'


    const getDetails = () => {
        return (
            <div style={{fontFamily, fontSize}}>
                {summary.length} feet ({(summary.length/5280).toFixed(2)} miles) reach
                <Plural
                    count={summary.crossSections}
                    singular={'cross section'}
                    plural={'cross sections'}
                    render={(count, text) => (
                        <>
                            <br/>
                            {count} {text}
                        </>
                    )}
                />
                <Plural
                    count={summary.single_bridge}
                    singular={'(single opening) bridge'}
                    plural={'(single opening) bridges'}
                    render={(count, text) => {
                        return (
                            <>
                                <br/>
                                {count} {text}
                            </>
                        )
                    }}
                />
                <Plural
                    count={summary.multiple_bridge}
                    singular={'(multiple opening) bridge'}
                    plural={'(multiple opening) bridges'}
                    render={(count, text) => {
                        return (
                            <>
                                <br/>
                                {count} {text}
                            </>
                        )
                    }}
                />
                <Plural
                    count={summary.culverts}
                    singular={'culvert'}
                    plural={'culverts'}
                    render={(count, text) => {
                        return (
                            <>
                                <br/>
                                {count} {text}
                            </>
                        )
                    }}
                />
                <Plural
                    count={summary.inline}
                    singular={'inline structure'}
                    plural={'inline structures'}
                    render={(count, text) => {
                        return (
                            <>
                                <br/>
                                {count} {text}
                            </>
                        )
                    }}
                />
                <Plural
                    count={summary.profiles}
                    singular={'profile'}
                    plural={'profiles'}
                    render={(count, text) => (
                        <>
                            <br/>
                            {count} {text}
                            <Plural
                                count={summary.flowLocations}
                                singular={'location'}
                                plural={'locations'}
                                render={(count, text) => {
                                    return ` with ${count} flow change ${text}`
                                }}
                            />
                        </>
                    )}
                />
            </div>
        )
    }

    if(report) {
        return getDetails()
    }

    return (
        <>
            <Card title={'Plan Summary'} style={{height: '100%'}}>
                {
                    summary.preparing && (
                        <>
                            Preparing for Check... {<Spin />}
                        </>
                    )
                }
                {
                    !summary.preparing && (!summary.length) && (
                        <div style={{width: 200, display: 'flex', alignItems:'center', gap: 8}}>
                            <img src={'/info.png'} width={36} height={36} alt={''}/>
                            <div>
                                Please Run
                            </div>
                        </div>
                    )
                }
                {
                    !summary.preparing && (summary.length) && getDetails()
                }
            </Card>
        </>
    )
}